import { ResponsiveCard } from '../../molecules/card/Card';

export function DrivingLicenseSleepCard() {
    return (
        <ResponsiveCard
            body="Lees meer over slaapapneu en autorijden"
            cardTitle="Autorijden met slaapapneu"
            icon="download"
            lg={12}
            linksText={['Informatie over autorijden met slaapapneu']}
            linksTo={['assets/documents/Sleep_driving_license.pdf']}
            openInNewTab={true}
            position="left"
        />
    );
}
